// removed by extract-text-webpack-plugin
module.exports = {"iconMenu":"Oo_Jr","item":"_2_MRM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionMenu/ActionMenu.scss
// module id = 2637
// module chunks = 0